import { createContext } from 'react';
import { AccountAndBillingHostProps, BillingSecondTab } from './types';

/** The host props as the feature's components see them: the page has already defaulted `secondTab`. */
export type AccountAndBillingContextValue = AccountAndBillingHostProps & { secondTab: BillingSecondTab };

export const AccountAndBillingContext = createContext<AccountAndBillingContextValue | null>(null);
